import * as Utils from "@/utils.js";
import apiClient from "./Environment";

export default {
  list(params) {
    return apiClient.get("/get-rate-change-log" + Utils.buildGetParams(params));
  },
  statuses(params) {
    return apiClient.get(
      "/get-rate-change-log-statuses" + Utils.buildGetParams(params)
    );
  },
  detail(changelogId, params) {
    return apiClient.get(
      "/get-rate-change-log-detail" +
        Utils.buildGetParams({ ...params, changelog_id: changelogId })
    );
  },
  retryPms(changelogId, params) {
    return apiClient.post(
      "/rate-change-log-retry-pms" +
        Utils.buildGetParams({ ...params, changelog_id: changelogId }),
      {}
    );
  },
  retrySnapshot(changelogId, params) {
    return apiClient.post(
      "/rate-change-log-retry-snapshot" +
        Utils.buildGetParams({ ...params, changelog_id: changelogId }),
      {}
    );
  }
};
